









import { Component, Prop, Vue } from 'vue-property-decorator';
import { FulfillingSquareSpinner } from 'epic-spinners';

@Component({
  components: { FulfillingSquareSpinner },
})
export default class Loader extends Vue {
  @Prop()
  size: string;

  @Prop({ default: '#e30613' })
  color: string;

  get convertedSize(): number {
    if (this.size === 's') {
      return 30;
    }
    if (this.size === 'xl') {
      return 60;
    }
    if (this.size === '2xl') {
      return 80;
    }

    return 40;
  }
}
